import styled from 'styled-components';

export const FolderViewContainer = styled.div`
  width: 100%;
`;

export const FolderGrid = styled.div<{ $isCompact?: boolean }>`
  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(${({ $isCompact }) => ($isCompact ? '160px' : '200px')}, 1fr)
  );
  gap: ${({ $isCompact }) => ($isCompact ? '0.85rem' : '1.5rem')};
  margin-bottom: ${({ $isCompact }) => ($isCompact ? '1.25rem' : '2rem')};
`;

export const FolderCard = styled.div<{ $isCompact?: boolean }>`
  border: 1px solid ${({ theme }) => theme.colors.border.light || '#e0e0e0'};
  border-radius: ${({ $isCompact, theme }) =>
    $isCompact ? theme.borderRadius.sm : '12px'};
  padding: ${({ $isCompact }) => ($isCompact ? '1rem' : '1.5rem')};
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease,
    transform 0.15s ease,
    background 0.15s ease;
  background: ${({ $isCompact, theme }) =>
    $isCompact ? theme.colors.background : 'white'};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-height: ${({ $isCompact }) => ($isCompact ? '128px' : '180px')};
  justify-content: center;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary || '#1976d2'};
    ${({ $isCompact }) =>
      $isCompact
        ? `box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);`
        : `
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      transform: translateY(-2px);
    `}
  }
`;

export const FolderIcon = styled.div<{ $isCompact?: boolean }>`
  font-size: ${({ $isCompact }) => ($isCompact ? '1.85rem' : '3rem')};
  margin-bottom: ${({ $isCompact }) => ($isCompact ? '0.4rem' : '0.75rem')};
`;

export const FolderName = styled.div<{ $isCompact?: boolean }>`
  font-size: ${({ $isCompact }) => ($isCompact ? '0.88rem' : '1rem')};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary || '#333'};
  margin-bottom: 0.5rem;
  word-break: break-word;
  width: 100%;
`;

export const FolderMeta = styled.div`
  width: 100%;
  margin-top: auto;
`;

export const FolderCount = styled.div<{ $isCompact?: boolean }>`
  font-size: ${({ $isCompact }) => ($isCompact ? '0.76rem' : '0.875rem')};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-weight: 500;
`;

export const DocumentsContainer = styled.div`
  margin-top: 2rem;
`;

export const BackButton = styled.button<{ $isCompact?: boolean }>`
  background: transparent;
  border: 1px solid ${({ theme }) => theme.colors.border.light || '#e0e0e0'};
  border-radius: ${({ $isCompact, theme }) =>
    $isCompact ? theme.borderRadius.sm : '6px'};
  padding: ${({ $isCompact }) =>
    $isCompact ? '0.35rem 0.7rem' : '0.5rem 1rem'};
  font-size: ${({ $isCompact }) => ($isCompact ? '0.8rem' : '0.875rem')};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.primary || '#333'};
  cursor: pointer;
  margin-bottom: ${({ $isCompact }) => ($isCompact ? '1rem' : '1.5rem')};
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &:hover {
    background: ${({ theme }) => theme.colors.background || '#f5f5f5'};
    border-color: ${({ theme }) => theme.colors.primary || '#1976d2'};
    color: ${({ theme }) => theme.colors.primary || '#1976d2'};
  }
`;
